import { setDiscoverManifestEntries } from '@fluidx/host-ux';
import { Locale, resolveLocale } from '@fluidx/utilities';
import { getContainerManifestEntries } from '@ms/office-web-host';
import { getLocalizedStringStore } from 'owa-localize';
import * as trace from 'owa-trace';
import { onDiscoverManifestFetched } from '../actions/internalActions';

export async function preloadDiscoverManifest() {
    // This will get the deployed manifest entries from the CDN.
    try {
        const locale = getLocalizedStringStore().currentLocale;
        const fluidLocale: Locale = resolveLocale(locale);
        const entries = await getContainerManifestEntries(fluidLocale);
        setDiscoverManifestEntries(entries);
        onDiscoverManifestFetched();
    } catch (error) {
        // We do not expect this to ever fail.
        trace.errorThatWillCauseAlert(`Fluid - failed to fetch discover entries ${error}`);
    }
}
